import { combineReducers } from 'redux';

import { appReducer } from '../App/store/app.reducer';

export const reducer = combineReducers({
  appReducer
})